import { memo } from 'react';
import Markup, { bodyClass } from './adminHome.jsx';
import { usePage, useLegacyController } from '../hooks/usePage';

// Static markup is memoised so React never re-renders over the DOM the live controller updates.
const PageMarkup = memo(Markup);

export default function Admin() {
  usePage({ title: 'Election Police Live Location Command Center - Hierarchy & 24h Tracking', bodyClass });
  useLegacyController(() => import('../legacy/admin.js'));
  return <PageMarkup />;
}
